export default __webpack_public_path__ + "static/media/TuDO_BANNER.311bf592.png";